import { useEffect, useRef } from 'react';

import type { ImageEntry } from '../types';

import STYLES from './SlidesIndicatorDesktop.module.scss';

type Props = {
  images: ImageEntry[];
  shownImageIndex: number;
  updateShownImageIndex: (index: number) => void;
};

const SlidesIndicatorDesktop = ({
  images,
  shownImageIndex,
  updateShownImageIndex,
}: Props) => {
  const activeThumbnailRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    activeThumbnailRef.current?.scrollIntoView({
      block: 'nearest',
      inline: 'nearest',
    });
  }, [shownImageIndex]);

  return (
    <div
      className={STYLES.row}
      role="list"
      data-testid="image-gallery-slideshow-thumbnails"
    >
      {images.map((image, index) => (
        <div
          role="listitem"
          key={image.url}
          ref={index === shownImageIndex ? activeThumbnailRef : undefined}
        >
          <button
            type="button"
            className={STYLES.thumbnail}
            aria-current={shownImageIndex === index}
            onClick={() => updateShownImageIndex(index)}
            aria-label={image.location}
          >
            <img src={image.url} alt="" className={STYLES.image} />
          </button>
        </div>
      ))}
    </div>
  );
};

export default SlidesIndicatorDesktop;
